export default __webpack_public_path__ + "static/media/intro2.bb2bb75b.mp3";